module.exports = __webpack_public_path__ + "9c676e68fda923cdc99e13afe548fdba.ttf";


//////////////////
// WEBPACK FOOTER
// ./assets/icons/ss-glyphish-filled.ttf
// module id = 350
// module chunks = 0